import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { NgOptimizedImage } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-start',
  imports: [RouterLink, MatButton, NgOptimizedImage, TranslatePipe],
  templateUrl: './start.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './start.component.scss',
})
export class StartComponent {}
